import { DropdownContainer, OptionsList } from 'components/list';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./SelectTime.css');

export type IRemindTimeValue = number | null;

interface ITimeOptions {
    label: string;
    value: IRemindTimeValue;
}

// Props
interface ISelectTimeProps {
    onChange?:
        | (({
              value,
              label,
          }: {
              value: IRemindTimeValue;
              label: string;
          }) => void)
        | null;
    value?: number | null;
    label?: string | null;
    formatting?: '24' | '12' | 24 | 12 | null;
}

// Component
@observer
export class RemindTime extends React.Component<ISelectTimeProps, {}> {
    static get defaultProps(): ISelectTimeProps {
        return {
            onChange: null,
            value: null,
            label: 'Time',
            formatting: 12,
        };
    }

    constructor(props: ISelectTimeProps) {
        super(props);
    }

    @computed private get options(): ITimeOptions[] {
        return [
            { value: null, label: 'Do not remind' },
            { value: 0, label: 'At the time' },
            { value: 5, label: '5 minutes before' },
            { value: 10, label: '10 minutes before' },
            { value: 15, label: '15 minutes before' },
            { value: 30, label: '30 minutes before' },
            { value: 60, label: '1 hour before' },
            { value: 120, label: '2 hours before' },
            { value: 180, label: '3 hours before' },
            { value: 360, label: '6 hours before' },
            { value: 1440, label: '1 day before' },
            { value: 2880, label: '2 days before' },
            { value: 4320, label: '3 days before' },
            { value: 10080, label: '1 week before' },
            { value: 20160, label: '2 weeks before' },
        ];
    }

    public render() {
        return (
            <DropdownContainer
                ref={this.referenceDropdown}
                maxHeight={400}
                label={null}
                value={
                    typeof this.props.value !== 'undefined'
                        ? this.props.label
                        : undefined
                }
            >
                <OptionsList
                    label="Reminders"
                    onChange={this.handleValueChange}
                    options={this.options}
                    value={this.props.value}
                />
            </DropdownContainer>
        );
    }

    private dropdown: DropdownContainer = null;
    private referenceDropdown = (ref: DropdownContainer) =>
        (this.dropdown = ref);

    private handleValueChange = (changed: {
        value: number | null;
        label: string;
    }) => {
        if (this.props.onChange) {
            this.props.onChange(changed);
        }

        if (this.dropdown) {
            this.dropdown.closeDropdown();
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/calendar/RemindTime.tsx